import vuetify                                    from "@/plugins/vuetify";
import { ValidationObserver, ValidationProvider } from "vee-validate/dist/vee-validate.full.esm";
import Vue                                        from "vue";
import App                                        from "./App.vue";
import i18n                                       from "./i18n";
import "./registerServiceWorker";
import router                                     from "./router";
import store                                      from "./store";

import VueYoutube from 'vue-youtube'
Vue.use(VueYoutube)

import {PluginManager} from "@/pluginManager/portalPlugin"
//import * as rules from 'vee-validate/dist/rules';

// Vue.use(Notify);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App)
}).$mount('#app');
